import { render, staticRenderFns } from "./AddLanguageModal.vue?vue&type=template&id=5ead8061"
import script from "./AddLanguageModal.vue?vue&type=script&lang=ts"
export * from "./AddLanguageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports